import React, { Component } from 'react'
import classNames from 'classnames'
import { slides } from './new'
import { withRouter } from './withRouter'

class Aboutus extends Component {
  constructor(props) {
    super(props)

    this.IMAGE_PARTS = 4

    this.changeTO = null
    this.AUTOCHANGE_TIME = 4000

    this.state = { activeSlide: -1, prevSlide: -1, sliderReady: false }
  }

  componentWillUnmount() {
    window.clearTimeout(this.changeTO)
  }

  componentDidMount() {
    this.runAutochangeTO()
    setTimeout(() => {
      this.setState({ activeSlide: 0, sliderReady: true })
    }, 0)
  }

  runAutochangeTO() {
    this.changeTO = setTimeout(() => {
      this.changeSlides(1)
      this.runAutochangeTO()
    }, this.AUTOCHANGE_TIME)
  }

  changeSlides(change) {
    window.clearTimeout(this.changeTO)
    const { length } = slides
    const prevSlide = this.state.activeSlide
    let activeSlide = prevSlide + change
    if (activeSlide < 0) activeSlide = length - 1
    if (activeSlide >= length) activeSlide = 0
    this.setState({ activeSlide, prevSlide })
  }

  render() {
    const { activeSlide, prevSlide, sliderReady } = this.state
    return (
      <div className={classNames('slider', { 's--ready': sliderReady })}>
        <p className="slider__top-heading subheading">
          Nigeria's No.1 Distributor
        </p>
        <div className="slider__slides">
          {slides.map((slide, index) => (
            <div
              className={classNames('slider__slide', {
                's--active': activeSlide === index,
                's--prev': prevSlide === index,
              })}
              key={slide.city}
            >
              <div className="slider__slide-content">
                <h3 className="slider__slide-heading">
                  {' '}
                  {slide.city.split('').map((l) => (
                    <span> {l}</span>
                  ))}
                </h3>
                <h2 className="slider__slide-subheading">
                  {slide.country || slide.city}
                </h2>

                <p
                  className="slider__slide-readmore"
                  onClick={() => this.props.navigate(slide.readmore)}
                >
                  read more
                </p>
              </div>
              <div className="slider__slide-parts">
                {[...Array(this.IMAGE_PARTS).fill()].map((x, i) => (
                  <div className="slider__slide-part" key={i}>
                    <div
                      className="slider__slide-part-inner"
                      style={{ backgroundImage: `url(${slide.img})` }}
                    />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div
          className="slider__control"
          onClick={() => this.changeSlides(-1)}
        />
        <div
          className="slider__control slider__control--right"
          onClick={() => this.changeSlides(1)}
        />
      </div>
    )
  }
}

export default withRouter(Aboutus)
